export default __webpack_public_path__ + "/dist/images/f&b-producer.png";